module.exports = (fox) => {
  const { delay } = require("common-stuffs/utils")(fox);
  require("fox-dynamic-injection!fox-template-loader!../templates/defaultPlayer.tpl")(
    fox
  );

  fox.registerWidget(
    "LiveShowViewer",
    {
      requireResources() {
        return new fox.Promise((resolve) => {
          return require.ensure([], () => {
            resolve((fox._liveshowController = require("liveshow-controller")));
          });
        });
      },

      configure(options) {
        this.registerOptions("", {
          playerWidget: "#banner",
          playerContainerId: "flash-player-liveshow",
          streamatePopup: false,
          popupAddClass: false,
          widgets: {
            banner: {
              widget: "Widget",
              manualRender: true,
              "embed.container": "#liveshow-banner-container",
              template: "liveshowBanner",
              "hooks.onStartRendering": function () {
                if (this.getParent().mDeviceDetect()) {
                  this.templateOptions.mobile = "mobile-detect";
                }
              },
            },
            timer: {
              widget: "JQTimer",
              "embed.widget": "@parent #banner",
              "embed.container": ".show-start-time",
              autoRender: false,
              "handleWom.timerStopHandler": {
                callback: "@parent:checkLiveShows",
              },
              "handleWom.addedToDom": {
                widget: "@this",
                event: "addedToDom",
                callback: "@parent:customizeCounter",
              },
            },
          },
          handleWom: {
            modelConnected: {
              event: "inboxSocketEventLiveshow:connect",
              widget: "@root #socket",
              callback: "modelConnected",
            },
            failureStartApiResponse: {
              widget: "#getStartedLiveshowApi",
              event: ["failure", "false"],
              callback: "failureStartApiHandler",
            },
            playerRendered: {
              event: "playerRendered",
              widget: "@this",
              callback: function () {
                var tipmeContainer = fox.dom.selectFirst("#tipme-form");
                if (!!tipmeContainer) {
                  tipmeContainer.parentElement.style.display = "";
                }
              },
              "params.alwaysActive": true,
            },
            restartLiveshow: {
              event: "restartLiveshow",
              widget: "#lsTranslator",
              callback: "checkLiveShows",
            },
            requestError: {
              event: "paid_request_error",
              widget: "#lsTranslator",
              callback: "onRequestError",
            },
          },
        });

        this.callParent("configure", arguments);
      },

      init: function () {
        this.embedWidget("liveshowPopup", "Dialog", {
          template: "",
          useUiPosition: false,
          preventHideOnShadowClick: true,
          dialog: {
            title: "Live Show",
            width: 985,
            dialogClass: this.getOption("popupAddClass"),
            closeText: "",
          },
          "widgets.player": {
            widget: "Widget",
            autoRender: true,
            template: this.getOption("player.template") || "defaultPlayer",
            "templateOptions.playerContainerId":
              this.getOption("playerContainerId"),
          },
        });

        this.callParent("init", arguments);
      },

      running: function () {
        this.callParent("running", arguments);
        this.checkLiveShows();
      },

      activate: function () {
        this.callParent("activate", arguments);
        this.checkLiveShows();
      },

      checkLiveShows(sessionId, waitResp) {
        const params = sessionId ? { id: sessionId } : {};
        const promise = this.getApi("getStartedLiveshowApi", {
          method: "Liveshow.getStarted",
          sendTimezone: true,
        }).psend(params);

        if (waitResp !== true)
          return promise
            .then((...args) => this.successStartApiHandler(...args))
            .catch((e) => fox.exception(e));

        return promise;
      },

      getLsTranslator() {
        return this.wom1("#lsTranslator");
      },

      removeLSTranslator() {
        const t = this.getLsTranslator();

        if (t && t.isEmbedded()) {
          t.removeFromDom();
        }

        return this;
      },

      successStartApiHandler({ params: data }) {
        const {
          answer: { response },
        } = data;
        const banner = this.wom1("#banner");
        /**
         * Еретик, @Kratos -янчик, что это за ересь написана? :-)
         */
        // const banner = this.wait('#banner', 'addedToDom').then(function() {
        // 	this.wom1('#banner')
        // }.bind(this));
        const tplOptions = {
          addVars: { private: 0 },
          success: {},
          liveShowAllowed: false,
          isStreamateUser: this.isStreamateUser(),
        };

        if (response === false) {
          tplOptions.success.status = "no_liveshow";
          this.renderBanner(tplOptions);

          return this.removeLSTranslator();
        }

        tplOptions.addVars = { private: response.addVars.private };

        const {
          sign,
          host,
          id,
          streamName,
          stunServer,
          token,
          uid,
          appId,
          channelName,
        } = response;

        if (sign) {
          if (banner && banner.isEmbedded()) banner.removeFromDom();

          tplOptions.success.status = "inited";
          tplOptions.liveShowAllowed = true;

          if (!response.addVars.streamate && this.isStreamateUser()) {
            tplOptions.liveShowAllowed = false;
          }

          this.setOption("connectParams", {
            id,
            sign,
            host,
            streamName,
            stunServer,
            token,
            uid,
            appId,
            channelName,
          });

          if (response.addVars.private) {
            this.setOption("connectParams.private", true);
          } else if (response.addVars.paid) {
            this.setOption("connectParams.paid", true);
          }

          if (response.addVars.trustedHash) {
            this.setOption(
              "connectParams.trustedHash",
              response.addVars.trustedHash
            );
          }

          let settings = { ...response };

          if (response.addVars.amount && response.addVars.period) {
            settings = fox.mixin(settings, {
              amount: response.addVars.amount,
              period: response.addVars.period,
              rateId: response.addVars.rateId,
            });
          }

          this.setOption("liveshowSettings", settings);

          return this.renderNewPlayer(1);
        }

        tplOptions.success.status = response.success.status;

        //streamate
        if (fox.site.member && response.success.status == "inited") {
          if (!response.addVars) {
            this.renderBanner(tplOptions);

            return this.removeLSTranslator();
          }

          //online
          if (
            fox.objectGet(response, "addVars.streamate.status") === "online"
          ) {
            if (this.getOption("streamatePopup") === true) {
              if (!this.isStreamateUser()) {
                var w = this.rwom1("#liveshowPopup #player");

                w.setOption("template", "streamate_iframe");
                w.setTemplateOptions("link", response.addVars.streamate.link);
                w.render();

                this.rwom1("#liveshowPopup").show();
              }
            } else {
              var w = this.rwom1("#banner");

              w.setOption("template", "streamate_iframe");
              this.renderBanner({
                link: fox.objectGet(response, "addVars.streamate.link"),
              });
            }
          }

          return this.removeLSTranslator();
        }

        //private liveshow not allowed
        if (fox.site.member && response.success.status == "private") {
          tplOptions.success.status = "inited";
          tplOptions.addVars.private = 1;
        }

        if (response.success && response.success.status == "next_liveshow") {
          var startDate = this.parseDate(response.addVars.startDate);
          var difference = fox.utils.getRemainingTime(startDate);
          var formatedDate = this.formatDate(startDate);
          this.rwom1("#timer").counterStart(difference);

          tplOptions.addVars = fox.clone(response.addVars);

          if (this.getOption("dontFormatStartData") !== true) {
            tplOptions.addVars.startDate = formatedDate;
          }

          if (startDate < new Date()) {
            tplOptions.success.status = "delay";
          }

          tplOptions.googleCalendarLink = this.generateGoogleLink(response);
        }

        this.renderBanner(tplOptions);

        return this.removeLSTranslator();
      },

      renderBanner(opts) {
        return this.rwom1("#banner").setTemplateOptions(opts).render();
      },

      failureStartApiHandler() {
        const result = { success: { status: "no_liveshow" } };

        this.rwom1("#banner").setTemplateOptions(result).render();
      },

      renderNewPlayer(render) {
        let renderPlayer;

        if (fox.getEnv("restrictNotStreamate") == 1) return;

        if (fox.isObject(render)) return;

        renderPlayer = render;

        if (this.getOption("streamatePopup") === true && renderPlayer != 1)
          return;

        const fv = { ...this.getOption("connectParams") };
        delete this.options.connectParams.paid;
        delete this.options.connectParams.private;
        delete this.options.connectParams.trustedHash;

        const embedFlash = (connectParams) => {
          let lsTranslator = this.getLsTranslator();

          const promise = this.wait("#lsTranslator", "addedToDom");

          if (!lsTranslator) {
            lsTranslator = this.embedWidget(
              "lsTranslator",
              "ClientLSTranslator",
              {
                "embed.container": "#" + this.getOption("playerContainerId"),
              }
            );

            lsTranslator.setConnectParams(connectParams).run();
          } else if (!lsTranslator.isActive()) {
            lsTranslator
              .cleanConnectParams()
              .setConnectParams(connectParams)
              .activate();
          } else {
            lsTranslator
              .cleanConnectParams()
              .setConnectParams(connectParams)
              .render(true);
          }

          lsTranslator.setLiveshowSettings(this.getOption("liveshowSettings"));

          this.playerStarted = true;

          return promise;
        };

        return embedFlash(fv).then(
          (resp) => resp !== false && this.dispatchEvent("playerRendered")
        );
      },

      customizeCounter: function (obj, scope) {
        obj = {
          0: "days",
          2: "hours",
          4: "minutes",
          6: "seconds",
        };
        fox.each(obj, function (val, key) {
          scope._counter.find(".part" + key).append("<div>" + val + "</div>");
        });
      },

      formatDate(d) {
        var date = new Date(d);

        var hours = date.getHours(),
          minutes = date.getMinutes(),
          half = "AM",
          locales = {
            days: [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
            month: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          result = "";
        if (hours >= 12) {
          hours -= 12;
          half = "PM";
        }

        if (minutes < 10) {
          minutes = "0" + minutes;
        }

        result =
          locales.days[date.getDay()] +
          ", " +
          locales.month[date.getMonth()] +
          " " +
          date.getDate() +
          ", " +
          hours +
          ":" +
          minutes +
          " " +
          half;

        return result;
      },

      parseDate(time) {
        const d = fox.utils.dateFormat("%Y,%m,%e,%H,%M,%S", time).split(",");

        return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
      },

      mDeviceDetect() {
        const platform = window.navigator.userAgent;
        const mDevices = [
          { device: "Android", platform: /Android/ },
          { device: "iPhone", platform: /iPhone/ },
          { device: "iPad", platform: /iPad/ },
          { device: "Symbian", platform: /Symbian/ },
          { device: "Windows Phone", platform: /Windows Phone/ },
          { device: "Tablet OS", platform: /Tablet OS/ },
        ];

        return mDevices.some(({ platform: itemPlatform }) =>
          itemPlatform.test(platform)
        );
      },

      deactivate: function () {
        this.callParent("deactivate", arguments);

        var indx = this._reactivationPool.indexOf("lsTranslator");

        if (indx !== -1) {
          this._reactivationPool.splice(indx, 1);
        }
      },

      isStreamateUser: function () {
        return fox.getEnv("restrictNotStreamate") === true;
      },

      modelConnected({ answer: { message: sessionId } } = {}) {
        return delay(2000)
          .then(() => this.checkLiveShows(null, true))
          .then((resp) => {
            const data = resp.params.answer.response;

            if (data.id !== sessionId) return this.checkLiveShows(sessionId);

            this.successStartApiHandler(resp);

            return true;
          })
          .catch(() => {
            const translator = this.getLsTranslator();

            if (translator.isEmbedded()) {
              translator.removeFromDom();
            }
          });
      },

      generateGoogleLink(resp) {
        let data = {};
        let startDate, finishDate, description, title;

        finishDate = fox.objectGet(resp, "addVars.finishDate");

        if (
          !finishDate ||
          finishDate === "0000-00-00" ||
          finishDate === "0000-00-00 00:00:00"
        ) {
          finishDate = null;
        }

        if ((startDate = fox.objectGet(resp, "addVars.startDate"))) {
          data["dates"] = fox.utils.dateFormat("%Y%m%dT%H%M%SZ", startDate);
        }

        data["dates"] = [
          data["dates"],
          fox.utils.dateFormat("%Y%m%dT%H%M%SZ", finishDate || startDate),
        ].join("/");

        if ((title = fox.objectGet(resp, "addVars.title"))) {
          data["text"] = title + ": liveshow by " + fox.getEnv("screenName");
        }

        if ((description = fox.objectGet(resp, "addVars.description"))) {
          data["details"] = description;
        }

        data["location"] = [window.location.origin, "liveshow"].join("/");

        return fox.utils.generateGoogleCalendarLink(data);
      },

      onRequestError: function (params) {
        var popup = this.wom1("#errorPopup");

        if (!popup) {
          popup = this.embedWidget("errorPopup", "Popup_Common", {
            "widgets.content": {
              template: "paid_request_error",
              templateOptions: { error: params.answer.code },
              "handleDom.close": {
                target: "#close",
              },
            },
          });
          popup.run();
        }

        return popup.show();
      },
    },
    "Controller"
  );
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/liveshowViewer.es.js